import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppData } from "./app-data.service";


@Injectable({
    providedIn: 'root'
})

export class CacheService {
    private loginFormData: any;
    private signupFormData: any;
    private promoHeroImageUrl;


    constructor() { }

    public setLoginFormData(formData: any) {
        this.loginFormData = formData;
    }

    public getLoginFormData() {
        return this.loginFormData;
    }

    public setSignupFormData(formData: any) {
        this.signupFormData = formData;
    }

    public getSignupFormData() {
        return this.signupFormData;
    }

    public setPromoHeroImageUrl(url: string) {
        this.promoHeroImageUrl = url;
    }

    public get getPromoHeroImageUrl(): string {
        return this.promoHeroImageUrl;
    }
    public setqueryParams(data) {
        // this.backNavData = data;
        // this.backNavQuery = params;l
        let navData = {}
        console.log('here is data', data)
        if (Object.keys(data).length > 0) {
            navData = {
                queryParams: data.queryParams
            }
        } else {
            navData = {
            }
        }
        AppData.backButtonInfo$.next(navData)
    }
    public toggleFooterNavOnExplore(data) {
        if (window.location.pathname === '/explore') {
            AppData.bottomNavBarHideOnExplore$.next(data)
        }
    }
}